import React from "react";
import withShipment from "../../../withShipment";
import CustomToolbar from "../../global/CustomToolbar";
import {
    BACK_TO_MENU,
} from "../ManageSuppliers/constants";
import {
    CLAIMS, CLAIMS_TOOLBAR_TITLE, FTL, FTL_TOOLBAR_TITLE,
    Process_Historical_TITLE, SUBMIT
} from "./constants";
import {
    Button, IconButton,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    TextField
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import './ImportFTLData.css'
import {CANCEL, SAVE} from "../../global/constants";
import {clearHistoricalData, importHistoricalData} from "../../../redux/actions/settings";
import {historicalDataSelector, productsSelector} from "../../../redux/selectors/settings";
import GlobalTableHead from "../../global/Table/GlobalTableHead";
import {Box, Typography} from "@mui/material";
import CircularProgress from "@material-ui/core/CircularProgress";

class ImportFTLData extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            onImportPage : false,
            source : "",
            processQueue: [],
            folderId: "",
            processing: false
        }

    }

    componentDidMount() {
        this.props.clearHistoricalData()
    }

    parseLines = (value) => value.replace(/(\\n)/g, "\n");

    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if(prevProps.historicalData !== this.props.historicalData && this.props.historicalData!="") {
            this.setState({
                processing: false
            })
        }
    }

    handleSubmit = async () => {
        const curImport = {
            folderId: this.state.folderId
        }
        this.props.importHistoricalData(curImport,FTL)
        this.setState({
            source: "",
            processQueue: [...this.state.processQueue, FTL],
            onImportPage: false,
            processing: true
        })
    }

    styleLineContent = (line) => {
        let styledLine;

        if (line.includes("high")) {
            styledLine = line.replace("high", "").replace(/(.*?):/, "<strong>$1</strong>:").replace("imported", "<span style='color: red;'>imported");
        } else if (line.includes("medium")) {
            styledLine = line.replace("medium", "").replace(/(.*?):/, "<strong>$1</strong>:").replace("imported", "<span style='color: orange;'>imported");
        } else if (line.includes("low")) {
            styledLine = line.replace("low", "").replace(/(.*?):/, "<strong>$1</strong>:").replace("imported", "<span style='color: green;'>imported");
        } else {
            styledLine = line;
        }

        // Add closing span tag
        if (styledLine.includes("imported")) {
            styledLine += "</span>";
        }

        return styledLine;
    }

    render() {
        const lines = this.props.historicalData.split('*');
        return (
            <>
                <CustomToolbar
                    creatingOrder={this.state.onImportPage}
                    title={FTL_TOOLBAR_TITLE}
                    createTitle={Process_Historical_TITLE}
                    backTitle={BACK_TO_MENU}
                    handleClose={() => {
                        this.setState({
                            onImportPage: false
                        })
                    }}
                    onClick={() => {
                        this.setState({
                            onImportPage: true
                        })
                    }}
                />

                {this.state.onImportPage &&
                    <>
                        <div style={{
                            display: "flex",
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '70%',
                            margin: '0 auto'
                        }}>

                            <TextField
                                value={this.state.folderId}
                                className={"input-select-field fullWidth"}
                                onChange={(event) => this.setState({ folderId: event.target.value })}
                                name="FTL Import Folder ID"
                                variant="outlined"
                                label="FTL Import Folder ID"
                                InputLabelProps={{ shrink: true }}
                            />

                            <div style={{display: "flex", flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: '25px'}}>
                                <Button
                                    variant='contained'
                                    onClick={() => this.setState({onImportPage:false})}
                                >
                                    {CANCEL}
                                </Button>
                                <div className='save-spacing' />
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={() => this.handleSubmit()}
                                    disabled={this.state.folderId == ""}
                                >
                                    {SUBMIT}
                                </Button>
                            </div>
                        </div>
                    </>
                }
                {!this.state.onImportPage &&
                    <Box
                        component="div"
                        padding={2}
                        margin={2}
                        border={1}
                        borderColor="divider"
                        borderRadius={2}
                    >
                        {lines.map((line, index) => {
                            const styledContent = this.styleLineContent(line.replace(/,/g, ""));
                            return (
                                <Box
                                    component="div"
                                    key={index}
                                    marginBottom={index !== lines.length - 1 ? 2 : 0}
                                >
                                    <Typography variant="h5" gutterBottom>
                                        <span dangerouslySetInnerHTML={{ __html: styledContent }} />
                                    </Typography>
                                </Box>
                            );
                        })}
                        { this.state.processing ?
                            <div>
                                <CircularProgress/>
                            </div>
                            :
                            ""
                        }
                    </Box>
                }
            </>
        );
    }


}


const mapStateToProps = (state) => ({
    historicalData: historicalDataSelector(state),
})

const actionCreators = {
    importHistoricalData,
    clearHistoricalData
}

ImportFTLData.propTypes = {

}

ImportFTLData.defaultProps = {

}

export default withShipment({
    mapStateToProps,
    actionCreators
}, ImportFTLData);